import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as i18next from 'i18next';
import moment from 'moment';
import * as api from 'core/api';
import * as auth from 'core/auth';
import * as flights from 'core/flights';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

export interface AccountProfileComponentModel {
    user: api.User | null;
}

@WithRender
@Component
export default class AccountProfileComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init

    @Prop()
    user: api.UserAccount;

    editing: boolean = false;

    dateMask: string | null = null;

    model: AccountProfileComponentModel | null = null;

    profileSubmitted: boolean = false;

    userBirthday: string | null = null;

    userCountry: string | null = null;

    userCity: string | null = null;

    userGender: flights.Gender | null = null;

    userNextTripPurposes: string[] = [];

    //@Watch('model.user.birthday')
    //onBirthdayChanged(val: string) {
    //    if (val) {
    //        this.userBirthday = moment(val, 'YYYY-MM-DD').format('L');
    //    }
    //}

    //@Watch('model.user.gender')
    //onGenderChanged(val: string) {
    //    if (val) {
    //        if (val.toLowerCase() === 'male') {
    //            this.userGender = flights.Gender.Male;
    //        }
    //        else if (val.toLowerCase() === 'female') {
    //            this.userGender = flights.Gender.Female;
    //        }
    //    }
    //}

    mounted() {
        this.dateMask = moment().localeData().longDateFormat('L').replace(/(D|M|Y)/gi, '#');

        if (this.user.birthday) {
            this.userBirthday = moment(this.user.birthday, 'YYYY-MM-DD').format('L');
        }

        this.model = {
            user: null
        };
    }

    get nextTripPurposesLabel() {
        let result = '';

        this.user.allNextTripPurposes.forEach((item) => {
            if (this.user.nextTripPurposes.indexOf(item.id) >= 0) {
                if (result) {
                    result += ', ';
                }

                result += item.name;
            }
        });

        if (result) {
            return result;
        } else {
            return '&ndash;';
        }
    }

    get selectCountries() {
        const result: any = this.user.countries.map((country) => {
            return {
                label: country.localizedName,
                value: country.uniqueId
            };
        });

        if (result.length > 0) {
            result.unshift({label: '', value: null});
        }

        return result;
    }

    get selectCities() {
        const result = this.user.cities.map((city): {
            label: string | null;
            value: number | null;
        } => {
            return {
                label: city.localizedName,
                value: city.uniqueId
            };
        });

        result.unshift({ label: '', value: null });

        return result;
    }

    get selectNextTripPurposes() {
        return this.user.allNextTripPurposes.map((item) => {
            return {
                label: item.name,
                value: item.id
            };
        });
    }

    get genderLabel() {
        if (this.user.gender) {
            return i18next.t('label_gender_' + (<any>this.user.gender).toLowerCase());
        } else {
            return '&ndash;';
        }
    }

    get genderOptions() {
        return [
            {
                label: '',
                value: null
            },
            {
                label: i18next.t('label_gender_' + flights.Gender[flights.Gender.Male].toLowerCase()),
                value: flights.Gender.Male
            },
            {
                label: i18next.t('label_gender_' + flights.Gender[flights.Gender.Female].toLowerCase()),
                value: flights.Gender.Female
            }
        ];
    }

    onBirthdayChange(v) {
        if (v) {
            const m = moment(v, moment().localeData().longDateFormat('L'), true);

            if (m.isValid()) {
                this.model!.user!.birthday = m.format('YYYY-MM-DD');
            }
        } else {
            this.model!.user!.birthday = '';
        }
    }

    onCountryChange() {
        this.userCity = null;
        this.model!.user!.city = null;

        if (this.userCountry) {
            this.model!.user!.country = this.user.countries.find(c => c.uniqueId == parseInt(this.userCountry!)) || null;

            new api.DestinationService().listCities(this.userCountry).then(
                (result: api.Destination[]) => {
                    this.user.cities = result;
                },
                () => {}
            );
        } else {
            this.model!.user!.country = null;
            this.user.cities = [];
        }
    }

    onCityChange() {
        if (this.userCity) {
            this.model!.user!.city = this.user.cities.find(c => c.uniqueId == parseInt(this.userCity!)) || null;
        } else {
            this.model!.user!.city = null;
        }
    }

    onEditShow() {
        this.model!.user = {
            city: this.user.city,
            country: this.user.country,
            email: null,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            phone: null,
            birthday: this.user.birthday,
            gender: this.user.gender,
            hasPassword: false,
            nextTripPurposes: this.user.nextTripPurposes,
            roles: null
        };

        this.userGender = this.user.gender ? flights.Gender[this.user.gender] : null;
        this.userCity = this.user.city ? this.user.city.uniqueId.toString() : null;
        this.userCountry = this.user.country ? this.user.country.uniqueId.toString() : null;

        this.editing = true;
    }

    onGenderChange() {
        this.model!.user!.gender = flights.Gender[this.userGender!];
    }

    onProfileSubmit() {
        this.profileSubmitted = true;

        this.$auth.updateProfile(this.model!.user!).then(
            () => {
                this.profileSubmitted = false;

                if (this.model && this.model.user) {
                    this.user.gender = this.model.user.gender;
                    this.user.lastName = this.model.user.lastName;
                    this.user.firstName = this.model.user.firstName;
                    this.user.birthday = this.model.user.birthday;
                    this.user.country = this.model.user.country;
                    this.user.city = this.model.user.city;
                    this.user.nextTripPurposes = this.model.user.nextTripPurposes;
                }

                this.editing = false;
            },
            (error) => {
                this.profileSubmitted = false;

                (<any>this.$root).$refs.dialogMessage.show({
                    text: (error.response.data && error.response.data.localizedMessage) ? error.response.data.localizedMessage : i18next.t('error_server_tryagain')
                });

                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }
}
